import React, { FC } from 'react'
import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Divider,
  SimpleGrid,
  Stack,
  Text,
  useBreakpointValue,
} from '@chakra-ui/react'

interface Props {
  title: string
  items: Array<VehicleGlobal.Feature>
}

const Column: FC<Props> = ({ title, items }) => {
  const isMobile = useBreakpointValue({ base: true, md: false })

  return isMobile ?
    <Accordion allowToggle allowMultiple defaultIndex={0}>
      <AccordionItem border="0" borderBottom="1px solid #dadde1">
        <h2>
          <AccordionButton p="m" _hover={{ background: 'none' }}>
            <Box
              flex="1"
              textAlign="left"
              fontSize="1rem"
              fontFamily="Montserrat-SemiBold"
              textTransform="uppercase"
            >
              {title}
            </Box>
            <AccordionIcon />
          </AccordionButton>
        </h2>
        <AccordionPanel pb={4}>
          <Stack align="flex-start">
            {items &&
              items.map(item => (
                <SimpleGrid
                  key={item.name}
                  columns={2}
                  w="100%"
                  p="12px"
                  className="accordion-item-mobile-bordered"
                >
                  <Text
                    fontFamily="Montserrat-Regular"
                    fontSize="1rem"
                    letterSpacing=".2px"
                    color="baseDark"
                    display="inline"
                    textTransform="uppercase"
                    textAlign="left"
                  >
                    {item.name}
                  </Text>
                  <Text
                    fontFamily="Montserrat-SemiBold"
                    fontSize="1.1rem"
                    letterSpacing=".3px"
                    color="baseDark"
                    display="inline"
                    textAlign="right"
                  >
                    {item.value}
                  </Text>
                </SimpleGrid>
              ))
            }
          </Stack>
        </AccordionPanel>
      </AccordionItem>
    </Accordion>
    :
    <Box w="full" bg="baseWhite" p={6} overflow="hidden" padding="unset">
      <Text
        fontFamily="Montserrat-SemiBold"
        fontSize=".875rem"
        lineHeight="18px"
        letterSpacing=".2px"
        textAlign="center"
        color="baseDark"
        textTransform="uppercase"
        paddingY="m"
      >
        {title}
      </Text>
      <Divider bg="baseNeutral.300" height=".125rem" />
      <Stack paddingX="xl" paddingY="l">
        {items.map(item => (
          <Box position="relative" textAlign="left" key={`${item.name}-${item.value}`}>
            <Box paddingY=".875rem" paddingX="s">
              <Text
                fontFamily="Montserrat-Regular"
                fontSize="1rem"
                lineHeight="20.8px"
                letterSpacing=".2px"
                color="baseDark"
                display="inline"
                textTransform="uppercase"
              >
                {item.name}
              </Text>
              <Text
                fontFamily="Montserrat-SemiBold"
                fontSize="1.1rem"
                lineHeight="23px"
                letterSpacing=".3px"
                float="right"
                color="baseDark"
                display="inline"
              >
                {item.value}
              </Text>
            </Box>
            <Divider bg="baseNeutral.300" height=".062rem" />
          </Box>
        ))}
      </Stack>
    </Box>
}

export default Column
